import {
  updateItemQuantityAction,
  removeLineItemAction,
  removeAllItemAction,
  setUserLastActiveTime,
  removeCouponAction,
  updateLineitemAction,
} from '@kfc-global/react-shared/redux/Actions/CartAction';
import { CART_PAGE_CONSTANTS } from 'organisms/CartPage/Constants/CartPageConstants';
import { getPayloadForRemoveFromCart, generatePDPurl, setAnalyticsData } from '../../Utils/cartPageUtils';
import { fetchItemDetailsAction } from '@kfc-global/react-shared/redux/Actions/MenuAction';
import START_ORDER_CONSTANTS from 'organisms/StartOrderComponent/Constants/startOrderConstants';
import { MENU_PDP_PAGE_CONSTANTS } from 'organisms/MenuPDPPage/AU/Constants/MenuPDPPageConstants';
import { quantityIncreaseDecreaseFromCart } from 'organisms/MenuPDPPage/AU/Presentation/ReusableComponents/PdpAnalytics';
import {
  LOCAL_STORAGE_KEYS,
  ROUTE_URL,
  SESSION_STORAGE_KEYS,
  ANALYTICS_SHARED_CONSTANTS,
} from 'common/constants/SharedConstants';
import { checkForQuantityLimit } from 'organisms/MenuPDPPage/AU/Utilities/MenuPDPUtils';
import { RecommendedItemAnalytic } from 'common/utilities/analyticsUtils';
import { getTernaryValue, isCateringDisposition } from 'common/utilities/utils';
import { setPWAstorage } from '@kfc-global/react-shared/redux/Slices/PwaStorageSlice';
const {
  QUANTITY_ACTION,
  ANALYTICS_EVENTS,
  CART_ALERT,
  PDP_DATA_FOR_UPDATE_FOODLINE,
  CUSTOMISE_FLAG_CART,
  REMOVE_ITEM_FLAG,
} = CART_PAGE_CONSTANTS;
const { MINI_PDP_DATA, FROMFLAGEDIT, EDIT_CLICKED } = START_ORDER_CONSTANTS;
const { RESET_MODGROUP_IDS_UPDATE, SHOW_PDP_ALERT_POPUP } = MENU_PDP_PAGE_CONSTANTS;

export default function cartItemListHandlers(
  cartSummary,
  tenantId,
  cartItems,
  productMapByItemId,
  userOrderStateDispatch,
  dispatch,
  history,
  categories = [],
  userType,
  currencyShortname = '',
) {
  const itemQuantityHandler = (item, action) => {
    let { quantity, foodLineId } = item;
    const { cartId, discountAmounts = [], totalAmount } = cartSummary;
    const { unitPrice } = item;
    const updatedTotalAmount = unitPrice + +totalAmount;
    if (quantity && foodLineId && cartId && tenantId) {
      if (action === QUANTITY_ACTION.Increase) {
        checkForQuantityLimit(quantity, true, item);
      }
      quantity =
        action === QUANTITY_ACTION.Increase
          ? quantity + 1
          : (action === QUANTITY_ACTION.Decrease && quantity - 1) || quantity;
      dispatch(
        updateItemQuantityAction(
          {
            params: {
              basketId: cartId,
              basketLineItemId: foodLineId,
            },
            tenantId: tenantId,
          },
          { quantity },
        ),
      );
      dispatch(setUserLastActiveTime(new Date()));
    }
    const event = action === QUANTITY_ACTION.Increase ? ANALYTICS_EVENTS.ADD_TO_CART : ANALYTICS_EVENTS.REMOVE;
    const itemObj = getPayloadForRemoveFromCart(
      [item],
      productMapByItemId,
      'quantityModified',
      discountAmounts,
      categories,
    );
    if (action === QUANTITY_ACTION.Increase) {
      RecommendedItemAnalytic(userType, itemObj, +updatedTotalAmount.toFixed(2), currencyShortname);
    } else {
      quantityIncreaseDecreaseFromCart(event, itemObj);
    }
  };

  const itemEditHandler = item => {
    const { foodItemId: productId = '', foodLineId } = item;
    const { catalog } = cartSummary;
    userOrderStateDispatch({ type: RESET_MODGROUP_IDS_UPDATE });
    userOrderStateDispatch({
      type: EDIT_CLICKED,
      value: { cartEditClicked: true },
    });
    userOrderStateDispatch({
      type: MINI_PDP_DATA,
      value: { id: productId, flag: FROMFLAGEDIT, foodLineId: foodLineId },
    });
    dispatch(
      fetchItemDetailsAction({
        tenantId: tenantId,
        catalogName: catalog,
        itemId: productId,
      }),
    );
    setAnalyticsData(ANALYTICS_EVENTS.EDIT);
    dispatch(setUserLastActiveTime(new Date()));
  };

  const itemRemoveHandler = (item, callback) => {
    let { foodLineId } = item;
    const { cartId } = cartSummary;
    if (foodLineId && cartId && tenantId) {
      dispatch(
        removeLineItemAction({
          tenantId,
          basketId: cartId,
          basketLineItemId: foodLineId,
        }),
      );
      /*setting removeItemCart value true, to stop opening of Add-Ons Modal on Remove button */
      userOrderStateDispatch({ type: REMOVE_ITEM_FLAG, value: { removeItemCart: true } });
    }
    const itemObj = getPayloadForRemoveFromCart(
      [item],
      productMapByItemId,
      'removeAllQty',
      cartSummary?.discountAmounts,
      ANALYTICS_SHARED_CONSTANTS.AUD,
    );
    if (callback) {
      callback(itemObj);
    }
    dispatch(setUserLastActiveTime(new Date()));
  };

  const itemAllRemoveHandler = () => {
    showCartAlert(true);
  };

  const itemAllRemoveAction = items => {
    const { cartId } = cartSummary;
    if (cartId && tenantId) {
      dispatch(
        removeAllItemAction({
          basketId: cartId,
          tenantId,
        }),
      );
    }
    showCartAlert(false);
    let itemObj = getPayloadForRemoveFromCart(items, categories, 'removeAllQty');
    quantityIncreaseDecreaseFromCart(ANALYTICS_EVENTS.REMOVE, itemObj);
    dispatch(setUserLastActiveTime(new Date()));
  };

  const showCartAlert = showCartAlertInfo => {
    userOrderStateDispatch({
      type: CART_ALERT,
      value: { showCartAlertInfo },
    });
  };

  const addMoreMenuHandler = dispositionType => {
    const pathname = getTernaryValue(
      isCateringDisposition(dispositionType),
      ROUTE_URL.CATERING_PAGE,
      ROUTE_URL.MENU_PAGE,
    );
    history.push({
      pathname,
    });
    dispatch(setUserLastActiveTime(new Date()));
  };
  const navigateToPromos = () => {
    history.push({
      pathname: ROUTE_URL.PROMOS_REWARDS,
    });
    dispatch(setUserLastActiveTime(new Date()));
  };
  const updateLocalStorage = couponCode => {
    if (localStorage.getItem(LOCAL_STORAGE_KEYS.ADD_TO_ORDER)) {
      const couponsInStorage = JSON?.parse(localStorage?.getItem(LOCAL_STORAGE_KEYS.ADD_TO_ORDER));

      if (couponsInStorage?.[couponCode]) {
        delete couponsInStorage[couponCode];
      }

      if (Object.keys(couponsInStorage).length > 0) {
        localStorage.setItem(LOCAL_STORAGE_KEYS.ADD_TO_ORDER, JSON.stringify(couponsInStorage));
      } else {
        localStorage.removeItem(LOCAL_STORAGE_KEYS.ADD_TO_ORDER);
      }
    }
  };
  const promosRemoveHandler = (couponCode, item) => {
    const { cartId } = cartSummary;
    if (couponCode) {
      dispatch(
        removeCouponAction(
          {
            basketId: cartId,
            tenantId,
            couponCode: couponCode,
          },
          () => {
            item ? productPromosRemoveHandler(couponCode, item) : updateLocalStorage(couponCode);
          },
        ),
      );
    }
  };

  /**
   * @tenant au
   * @param {*} flatResponse - Object
   * @param {*} item - Object
   * @param {*} history - object
   * when the user click on customise link from cart page, setting localstorage object (pdpdataforupdatefoodline) to make use in PDP
   * for updating the Foodline/ AddFoodline
   */
  const itemCustomiseHandler = (flatResponse, item, historyVal, dispositionType, sliceDispatch) => {
    const { foodItemId: productId = '', foodLineId } = item;
    const { catalog } = cartSummary;
    sliceDispatch(setPWAstorage({ key: SHOW_PDP_ALERT_POPUP, value: false }));
    userOrderStateDispatch({
      type: PDP_DATA_FOR_UPDATE_FOODLINE,
      value: { id: productId, flag: CUSTOMISE_FLAG_CART, foodLineId: foodLineId, isProductPromo: item?.isProductPromo },
    });
    dispatch(
      fetchItemDetailsAction({
        tenantId: tenantId,
        catalogName: catalog,
        itemId: productId,
      }),
    );
    historyVal.push({
      pathname: generatePDPurl(flatResponse, item, dispositionType),
    });
    localStorage.setItem(LOCAL_STORAGE_KEYS.CUSTOMISE_ITEM_CART, true);
    sessionStorage.setItem(SESSION_STORAGE_KEYS.CUSTOMISE_PDP_FLAG, true);
  };

  const productPromosRemoveHandler = (couponCode, item) => {
    let payloaddata = {};
    const { cartId } = cartSummary;
    if (localStorage.getItem(LOCAL_STORAGE_KEYS.ADD_TO_ORDER)) {
      const couponsInStorage = JSON?.parse(localStorage?.getItem(LOCAL_STORAGE_KEYS.ADD_TO_ORDER));
      if (couponsInStorage?.[couponCode]) {
        payloaddata = couponsInStorage[couponCode];
      }
    }
    if (+item?.discountAmount > 0) {
      dispatch(
        updateLineitemAction(
          {
            params: {
              basketId: cartId,
              basketLineItemId: item?.foodLineId,
            },
            tenantId,
          },
          { ...payloaddata, isProductPromo: false },
        ),
      );
    } else {
      itemRemoveHandler(item);
    }
    updateLocalStorage(couponCode);
  };

  return {
    itemQuantityHandler,
    itemRemoveHandler,
    itemAllRemoveHandler,
    itemAllRemoveAction,
    addMoreMenuHandler,
    itemEditHandler,
    showCartAlert,
    itemCustomiseHandler,
    navigateToPromos,
    promosRemoveHandler,
  };
}
